class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.refresh_token;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.jwt_token;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem('user'));
    user.jwt_token = token;
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser() {
    if (localStorage.getItem('user')) {
      const user = JSON.parse(localStorage.getItem('user'));
      if (new Date() > new Date(user.refresh_expiration)) {
        localStorage.removeItem('user')
        window.location.href = user.account.admin_uuid ? '/admin/signin' : '/signin'
      } else
        return user;
    }
    else window.location.href = '/signin';
  }

  isUser() {
    if (localStorage.getItem('user'))
      return true
    else
      return false
  }

  setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  removeUser() {
    const user = JSON.parse(localStorage.getItem('user'))
    localStorage.removeItem('user')
    // Clear session storage as well
    sessionStorage.clear()
    // Redirect and replace history to prevent back button access
    if (user.account.admin_uuid) {
      window.location.replace('/admin/signin')
    } else {
      window.location.replace('/signin')
    }
  }
}

// eslint-disable-next-line
export default new TokenService();